if (!customElements.get("card-slider")) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();
      this.secondaryNavigationListeners = [];

      const swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};

      window.addEventListener("shopify:section:load", () => {
        this.initSlider(swiperOptions);
      });

      this.initSlider(swiperOptions);

      if (this.classList.contains("js-testimonials")) {
        const initOrUpdateSlider = () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider && this.slider.params.effect === "slide";

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        };

        initOrUpdateSlider();

        window.addEventListener("resize", initOrUpdateSlider);
      }

      // if window is resized, re-init slider
      window.addEventListener("resize", () => {
        if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
          if (this.slider) {
            this.slider.destroy();
          }
        } else if (!this.slider) {
          this.initSlider(swiperOptions);
        }
      });
    }

    reInitSlider(swiperOptions) {
      this.destroySecondaryNavigation();
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    destroySecondaryNavigation() {
      this.secondaryNavigationListeners.forEach(({ button, handler }) => {
        button.removeEventListener("click", handler);
      });

      this.secondaryNavigationListeners = [];
    }

    initSecondaryNavigation(swiperOptions) {
      const navigationOptions = swiperOptions.navigation || {};
      const sectionRoot =
        document.querySelector(`#shopify-section-${swiperOptions.sectionId}`) ||
        document;
      const secondaryPrevButtons = navigationOptions.secondaryPrevEl
        ? Array.from(sectionRoot.querySelectorAll(navigationOptions.secondaryPrevEl))
        : [];
      const secondaryNextButtons = navigationOptions.secondaryNextEl
        ? Array.from(sectionRoot.querySelectorAll(navigationOptions.secondaryNextEl))
        : [];

      if (!secondaryPrevButtons.length && !secondaryNextButtons.length) {
        return;
      }

      const syncButtonsState = () => {
        const isLocked = Boolean(this.slider?.isLocked);
        const canRewind =
          Boolean(this.slider?.params?.loop) || Boolean(this.slider?.params?.rewind);
        const disablePrev = isLocked || (!canRewind && Boolean(this.slider?.isBeginning));
        const disableNext = isLocked || (!canRewind && Boolean(this.slider?.isEnd));

        secondaryPrevButtons.forEach((button) => {
          button.disabled = disablePrev;
          button.classList.toggle("swiper-button-disabled", disablePrev);
          button.setAttribute("aria-disabled", `${disablePrev}`);
        });

        secondaryNextButtons.forEach((button) => {
          button.disabled = disableNext;
          button.classList.toggle("swiper-button-disabled", disableNext);
          button.setAttribute("aria-disabled", `${disableNext}`);
        });

        [...new Set(
          [...secondaryPrevButtons, ...secondaryNextButtons].map((button) =>
            button.closest(".swiper-buttons")
          )
        )].forEach((container) => {
          if (!container) {
            return;
          }

          container.style.display =
            disablePrev && disableNext ? "none" : "";
        });
      };

      const handlePrevClick = () => {
        if (!this.slider || this.slider.destroyed) {
          return;
        }

        this.slider.slidePrev();
      };

      const handleNextClick = () => {
        if (!this.slider || this.slider.destroyed) {
          return;
        }

        this.slider.slideNext();
      };

      secondaryPrevButtons.forEach((button) => {
        button.addEventListener("click", handlePrevClick);
        this.secondaryNavigationListeners.push({
          button,
          handler: handlePrevClick
        });
      });

      secondaryNextButtons.forEach((button) => {
        button.addEventListener("click", handleNextClick);
        this.secondaryNavigationListeners.push({
          button,
          handler: handleNextClick
        });
      });

      this.slider.on("afterInit", syncButtonsState);
      this.slider.on("fromEdge", syncButtonsState);
      this.slider.on("lock", syncButtonsState);
      this.slider.on("reachBeginning", syncButtonsState);
      this.slider.on("reachEnd", syncButtonsState);
      this.slider.on("slideChange", syncButtonsState);
      this.slider.on("unlock", syncButtonsState);
      this.slider.on("update", syncButtonsState);

      syncButtonsState();
    }

    initSlider(swiperOptions) {
      this.destroySecondaryNavigation();

      const progressCircle = document.querySelector(
        `.autoplay-progress--${swiperOptions.sectionId} svg`
      );
      const progressContent = document.querySelector(
        `.autoplay-progress--${swiperOptions.sectionId} span`
      );

      // swiperOptions.disabledOnMobile = true;
      if (
        swiperOptions.disabledOnMobile &&
        window.innerWidth < mobileWidth
      ) {
        return;
      }

      // Swiper Pagination Option
      if (swiperOptions.pagination == "render_bullet") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (i, className) {
            return `
              <button class="${className}">
                <span>${i + 1}</span>
              </button>
            `;
          }
        };
      } else if (swiperOptions.pagination == "progressbar") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          type: "progressbar"
        };
      } else if (swiperOptions.pagination == "bullets") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true
        };
      } else {
        swiperOptions.pagination = false;
      }

      // Swiper Loop Option Check - if swiperOptions.slideCount is less than 2, then loop is disabled
      if (swiperOptions.loop && swiperOptions.slideCount < 2) {
        swiperOptions.loop = false;
      }

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1.1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 16,
        resistanceRatio: 0.72,
        navigation: swiperOptions.navigation || { nextEl: ".swiper-button--next", prevEl: ".swiper-button--prev" },
        breakpoints: {
          480: {
            slidesPerView: "auto",
            spaceBetween: swiperOptions.spaceBetweenMobile || 2
          },
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 16
          }
        }
      };

      const isArticlesSlider = this.classList.contains("js-articles");
      const isCollectionSlider =
        this.classList.contains("js-collections");
      const isFeaturedProductsSlider = this.classList.contains(
        "js-featured-products"
      );

      if (isArticlesSlider || isCollectionSlider || isFeaturedProductsSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 2
        };
      } else if (this.classList.contains("horizontal-w-media")) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: swiperOptions.pagination || false,
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 1
            }
          },
          on: {
            autoplayTimeLeft(_s, time, progress) {
              progressCircle.style.setProperty("--progress", 1 - progress);
              progressContent.textContent = `${Math.ceil(time / 1000)}s`;
            }
          }
        };
      } else if (this.classList.contains("vertical-w-media")) {

        if (window.innerWidth > 750) {

        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (i, className) {
              return `<button class="${className}"><span>${
                i + 1
              }</span></button>`;
            }
          },
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (i, className) {
                  return `<button class="${className}"><span>${
                    i + 1
                  }</span></button>`;
                }
              }
            },
            990: {
              slidesPerView: 1,
              grid: {
                rows: 3
              }
            }
          }
        };

      } else {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          on: {
            autoplayTimeLeft(_s, time, progress) {
              progressCircle.style.setProperty(
                "--progress",
                1 - progress
              );
              progressContent.textContent = `${Math.ceil(
                time / 1000
              )}s`;
            }
          }
        };
      }


      } else if (this.classList.contains("carousel-none-media")) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: swiperOptions.pagination || false,
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 3.2
            }
          },
          on: {
            autoplayTimeLeft(_s, time, progress) {
              progressCircle.style.setProperty(
                "--progress",
                1 - progress
              );
              progressContent.textContent = `${Math.ceil(
                time / 1000
              )}s`;
            }
          }
        };
      } else {
        sliderOptions = {
          effect: "fade",
          slidesPerView: 1,
          rewind: true,
          followFinger: false,
          navigation: {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          }
        };
      }

      this.slider = new Swiper(this, sliderOptions);
      this.initSecondaryNavigation(swiperOptions);
    }
  }

  customElements.define("card-slider", CardSlider);
}
